import React from "react";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";

export default function RatingStars({ value = 0, size = "medium" }) {
  const rounded = Math.round(Number(value) || 0);

  return (
    <span className={`uas-stars uas-stars--${size}`} aria-label={`${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((star) =>
        star <= rounded ? (
          <StarRoundedIcon key={star} fontSize="inherit" />
        ) : (
          <StarBorderRoundedIcon key={star} fontSize="inherit" />
        )
      )}
    </span>
  );
}
